import React, { useEffect, useState } from "react";
import style from "./sideleft.module.css";
import { MdDashboard } from "react-icons/md";
import { MdPayment } from "react-icons/md";
import { TbPackageImport } from "react-icons/tb";
import { RiFileList2Line } from "react-icons/ri";
import { BiMessageDetail } from "react-icons/bi";
import { FaTags } from "react-icons/fa";
import { FiSettings, FiMenu } from "react-icons/fi";
import { MdSupportAgent } from "react-icons/md";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { useNavigate, useLocation } from "react-router-dom";
import routeNames from '../utils/routes.json';
import { motion, AnimatePresence } from "framer-motion";

function SideBarComponent() {
  const [activeTab, setActiveTab] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const isActive = (route) => location.pathname.startsWith(route);

  const onClick = (key) => {
    if (key === routeNames["chat-panel"]) {
      setIsCollapsed(true); 
    } else {
      setIsCollapsed(false); 
    }
    navigate(key);
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    setActiveTab(pathname);
    if(pathname=='/chat-panel'){
      setIsCollapsed(true); 
    }
  }, [location.pathname]);

    const handleLogout = () => {
    setIsOpen(false);
    localStorage.clear();
    window.location.reload();
    navigate('/login'); 
    console.log("Logged out");
  }
console.log(activeTab);


  return (
    
    <div className={isCollapsed ? `${style.leftSide} ${style.collapsed}` : style.leftSide}>
      <div className="flex justify-center p-2">
        {isCollapsed && (
          <div className="absolute top-4 left-4">
            <button onClick={() => setIsCollapsed(false)}>
              <FiMenu className="text-xl" />
            </button>
          </div>
        )}
      </div>
        <div className={style.menuWrapper}>
          
      <ul>
        <li className={location.pathname === "/" ? style.active : ""} onClick={() => onClick('/')}>
          <a className="flex items-center gap-2">
            <MdDashboard />
            {!isCollapsed &&activeTab!="/chat-panel" && "Dashboard"}
          </a>
        </li>

        <li className={isActive(routeNames["product-dashboard"]) ? style.active : ""} onClick={() => onClick(routeNames["product-dashboard"])}>
          <a className="flex items-center gap-2">
            <TbPackageImport className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" && "Add Product"}
          </a>
        </li>

        <li className={isActive(routeNames["Order-list"]) ? style.active : ""} onClick={() => onClick(routeNames["Order-list"])}>
          <a className="flex items-center gap-2">
            <RiFileList2Line className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" &&activeTab!="/chat-panel" && "Order List"}
          </a>
        </li>
         <li className={isActive(routeNames["sale-s"]) ? style.active : ""} onClick={() => onClick(routeNames["sale-s"])}>
          <a className="flex items-center gap-2">
            <FaTags className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" &&activeTab!="/chat-panel" && "Sales"}
          </a>
        </li>

        <li className={isActive(routeNames["chat-panel"]) ? style.active : ""} onClick={() => onClick(routeNames["chat-panel"])}>
          <a className="flex items-center gap-2">
            <BiMessageDetail className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" && "Chat Here"}
          </a>
        </li>

        <li className={isActive(routeNames["add-category"]) ? style.active : ""} onClick={() => onClick(routeNames["add-category"])}>
          <a className="flex items-center gap-2">
            <FiSettings className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" && "Settings"}
          </a>
        </li>

        <li className={isActive(routeNames["pay-ment"]) ? style.active : ""} onClick={() => onClick(routeNames["pay-ment"])}>
          <a className="flex items-center gap-2">
            <MdPayment className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" && "Payment"}
          </a>
        </li>

        <li className={isActive(routeNames["support-s"]) ? style.active : ""} onClick={() => onClick(routeNames["support-s"])}>
          <a className="flex items-center gap-2">
            <MdSupportAgent className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" && "Supports"}
          </a>
        </li>

        <li className={isOpen ? style.active : ""} onClick={(e) => { e.preventDefault(); setIsOpen(true); }}>
          <a className="flex items-center gap-2">
            <RiLogoutBoxRLine className="text-xl" />
            {!isCollapsed &&activeTab!="/chat-panel" && "Logout"}
          </a>
        </li>
      </ul>

</div>

      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/40 px-4"
          onClick={() => setIsOpen(false)}
        >
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-center text-lg font-semibold mb-6">Are You Sure You want to log out?</h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button onClick={() => setIsOpen(false)} className="w-full sm:w-auto px-4 py-2 border rounded hover:bg-gray-100 transition">Cancel</button>
              <button onClick={handleLogout} className="w-full sm:w-auto px-4 py-2 bg-black text-white rounded hover:bg-gray-800 transition">Log out</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SideBarComponent;